const getRankingDisplay = (rank: number) => {
  if (rank >= 1 && rank <= 3) {
    return <img className='mx-[5px] h-[29px] w-[22px]' src={`/img/rank/ico_ranking_0${rank}.png`} alt='rank' />;
  }

  return <div className='w-[32px]'>{rank || '-'}</div>;
};

export default getRankingDisplay;
